<template>
  <div id="app">
    <HeaderPartner v-if="isPartner()" :partner="partner"/>
    <NavbarComponent v-if="hasNavbar" />

    <YieldRails />
    <FooterComponent v-if="hasFooter" />
    <Pdpa v-if="!isPartner()" />
    <TagthaiDisclaimer v-if="isPartner(PARTNER_TAGTHAI)" />
  </div>
</template>

<script>
import humps from "humps";
import Cookies from "js-cookie";

import HeaderPartner from "./components/HeaderPartner.vue";
import NavbarComponent from "./components/Navbar.vue";
import FooterComponent from "./components/Footer.vue";
import Pdpa from "./components/PDPA.vue";
import TagthaiDisclaimer from "./components/TagthaiDisclaimer.vue";
import YieldRails from "./components/YieldRails.vue";
import {
  API_BASE_URL,
  API_MAJOR_VERSION,
  API_MINOR_VERSION
} from "@user/constant.js";
import { getJSON } from "lib/myAjax";
import {
  PAGE_VIEWED,
  USER_SIGNED_IN,
  USER_SIGNED_UP
} from "lib/clevertapConstants";
import clevertapMixin from "./mixins/clevertapMixin";
import clevertapPush from "lib/clevertapPush";
import { usePartner, PARTNER_TAGTHAI } from "./helpers/usePartner";

const queryString = require("query-string");

export default {
  components: {
    HeaderPartner,
    NavbarComponent,
    FooterComponent,
    Pdpa,
    YieldRails,
    TagthaiDisclaimer
  },
  mixins: [clevertapMixin],
  data() {
    const { appConfig } = window;
    const { hasNavbar, hasFooter } = appConfig;
    let gaHitPage;
    if (window.gaHitPage === false) {
      gaHitPage = false;
    } else {
      gaHitPage = true;
    }
    const { partner, isPartner } = usePartner();

    return {
      partner,
      isPartner,
      PARTNER_TAGTHAI,
      hasNavbar,
      hasFooter,
      gaHitPage
    };
  },
  created() {
    this.fetchConfig();
  },
  mounted() {
    this.$nextTick(() => {
      this.setUtmSourceCookies();
      this.initFB();
      this.setupClevertap();
      this.trackCurrentUrl();
    });
  },
  methods: {
    setUtmSourceCookies() {
      const { utmSource } = humps.camelizeKeys(
        queryString.parse(window.location.search)
      );
      if (utmSource) {
        const cookiesUtmSource = Cookies.get("utm_source");
        if (cookiesUtmSource != utmSource) {
          Cookies.set("utm_source", utmSource, { expires: 60, domain: '.hungryhub.com' });
        }
      }
    },
    fetchConfig() {
      const payload = queryString.stringify({
        minor_version: API_MINOR_VERSION
      });
      const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/config.json/?${payload}`;
      getJSON(
        url,
        result => {
          const response = humps.camelizeKeys(result);
          if (response.success) {
            this.$store.state.appConfig = response.data;
          }
        },
        error => {
          Rollbar.error("error get config", error);
        }
      );
    },
    // google analytics
    initGA() {
      this.$ga.require("GTM-M763BSF");
      this.$ga.require("GTM-NPV33XC");
    },
    initFB() {
      if (typeof fbq !== 'function') return;
      if (this.isUserSignedIn) {
        fbq("init", "954876137929918", {
          em: this.currentUser.email,
          fn: this.currentUser.name,
          ph: this.currentUser.phone
        });
      } else {
        fbq("init", "954876137929918");
      }
    },
    setupClevertap() {
      if (this.isUserSignedIn) {
        const { justSignedIn, justSignedUp } = window;
        if (justSignedIn || justSignedUp) {
          this.clevertapLogin();
        }

        if (justSignedIn) {
          this.clevertapTrackSignedIn();
        } else if (justSignedUp) {
          this.clevertapTrackSignedUp();
        }
        this.clevertapAskPushPermission();
      }
    },
    trackCurrentUrl() {
      const url = window.location.pathname;

      if (this.$data.gaHitPage) {
        this.$ga.page(url);
      }
      this.$fbq("track", "PageView");
      clevertapPush(PAGE_VIEWED, {
        pageTitle: window.document.title,
        url
      });
    },
    clevertapLogin() {
      this.$clevertap.onUserLogin.push({
        Site: this.clevertapPayload()
      });
    },
    clevertapTrackSignedUp() {
      clevertapPush(USER_SIGNED_UP, this.clevertapPayload());
    },
    clevertapTrackSignedIn() {
      clevertapPush(USER_SIGNED_IN, this.clevertapPayload());
    }
  }
};
</script>
